import { call, put, takeLatest } from 'redux-saga/effects'
import { UserTypes, UserActions } from './userSlice'
import api from '../../services/api'


function* fetchUserSaga() {
  const response = yield call(api.fetchUserBySub)

  if (response.ok) {
    yield put(UserActions.userSuccess(response.data))
  } else {
    yield put(UserActions.userFailure(response.problem))
  }
}

function* updateUserSaga(action) {
  const { userData } = action
  const response = yield call(api.updateUserBySub, userData)

  if (response.ok) {
    yield put(UserActions.updateSuccess(response.data))
  } else {
    const errorMsg = response.data?.message || response.data?.error || response.problem
    yield put(UserActions.updateFailure(errorMsg))
  }
}

function* createUserSaga(action) {
  const { userData } = action
  const response = yield call(api.createUser, userData)

  if (response.ok) {
    yield put(UserActions.createSuccess(response.data))
  } else {
    const errorMsg = response.data?.message || response.data?.error || response.problem
    yield put(UserActions.createFailure(errorMsg))
  }
}

function* uploadProfilePictureSaga(action) {
  const { file } = action
  const response = yield call(api.uploadUserProfilePic, file)

  if (response.ok) {
    yield put(UserActions.uploadProfilePictureSuccess(response.data))
  } else {
    yield put(UserActions.uploadProfilePictureFailure(response.problem))
  }
}

function* deleteUserProfilePicture(action) {
  const { publicId } = action
  const response = yield call(api.deleteUserProfilePicture, publicId)

  if (response.ok) {
    yield put(UserActions.deleteUserProfilePictureSuccess(response.data))
  } else {
    yield put(UserActions.deleteUserProfilePictureError(response.problem))
  }
}

function* searchUsersSaga(action) {
  const { q, role } = action
  const response = yield call(api.searchUsers, q, role)

  if (response.ok) {
    yield put(UserActions.searchingUsersSuccess(response.data))
  } else {
    yield put(UserActions.searchingUsersFailure(response.problem))
  }
}




export default function* userSaga() {
  yield takeLatest(UserTypes.FETCHING_USER_REQUEST, fetchUserSaga);
  yield takeLatest(UserTypes.CREATING_USER_REQUEST, createUserSaga);
  yield takeLatest(UserTypes.UPDATING_USER_REQUEST, updateUserSaga);
  yield takeLatest(UserTypes.UPLOADING_PROFILE_PICTURE_REQUEST, uploadProfilePictureSaga);
  yield takeLatest(UserTypes.DELETING_USER_PROFILE_PICTURE_REQUEST, deleteUserProfilePicture);
  yield takeLatest(UserTypes.SEARCHING_USERS_REQUEST, searchUsersSaga);
}
